import { Unionize } from 'utilitys/helpers/TsGeneral';
import { StateCreator, create } from 'zustand';
import { persist } from 'zustand/middleware';

import { OptionValue } from 'components/common/CustomizedStatusSelect/CustomizedStatusSelect.types';

import { DEFAULT_PAGE_VIEW_GRAPH_LINE_OPTIONS } from 'components/widgets/SCurve/Scurve.utils';

interface Props {
    isShowCriticalityAnnotation: boolean;
    isShowActivitiesAnnotation: boolean;
    graphLineOptions: OptionValue[];
    update: (value: Unionize<Omit<Props, 'update'>>) => void;
}

const state: StateCreator<Props> = (set) => ({
    isShowCriticalityAnnotation: false,
    isShowActivitiesAnnotation: false,
    graphLineOptions: DEFAULT_PAGE_VIEW_GRAPH_LINE_OPTIONS,
    update: (value) => set({ ...value }),
});

export const useScurveStore = create(persist(state, { name: 'SCurveStore' }));
